import { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { setTabSelected } from "../redux/data/dataSlice";
import { getWallet } from "../redux/data/dataActions";
import { injectPageScripts } from "../utils/loadScripts.js";
import { setupBaseMetaData } from "../utils/metaData.js";
import QrCreator from "qr-creator";
import "../assets/css/wallet.css";

function Wallet() {
    const dispatch = useDispatch();
    const walletData = useSelector(state => state.data.walletData);
    const memberSince = useSelector(state => state.data.memberSince);
    const userName = useSelector(state => state.data.userName);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // analytics variable
        window.digitalData.page.pageInfo.pageName = "nba:membership-hub:member-card";
        window.digitalData.page.pageInfo.siteSection = "nba:membership-hub";
        window.digitalData.site = { propertyName: "nba:web", league: "nba" };
        console.log("Wallet: analytics added");
        injectPageScripts();
        setupBaseMetaData();
    }, []);

    useEffect(() => {
        const nbaNav = document.getElementById("nba-nav");
        if (nbaNav) {
            nbaNav.style.display = "none";
        }
        const nbaFooter = document.getElementById("nba-footer");
        if (nbaFooter) {
            nbaFooter.style.display = "none";
        }
        let bodyElement = document.getElementById("body");
        if (bodyElement) {
            bodyElement.style.setProperty("background-color", "#000000", "important");
        }
        dispatch(setTabSelected("wallet"));
        localStorage.setItem('href', document.location.href);
        localStorage.setItem('fromWallet', '1');

        return () => {
            if (nbaNav) {
                nbaNav.style.display = "";
            }
            if (nbaFooter) {
                nbaFooter.style.display = "";
            }
            if (bodyElement) {
                bodyElement.style.removeProperty("background-color");
            }
        };
    }, [dispatch]);

    useEffect(() => {
        if (!walletData) {
            dispatch(getWallet());
        }
        else if (walletData && walletData.qr_data) {
            QrCreator.render({
                text: walletData.qr_data,
                radius: 0, // 0.0 to 0.5
                ecLevel: "H", // error correction: L, M, Q, H
                fill: "#000000", // foreground color
                background: null, // color or null for transparent
                size: 156 // in pixels
            }, document.querySelector("#qr-code"));
        }
    }, [walletData, dispatch]);

    useEffect(() => {
        if (!walletData || !memberSince) {
            return;
        }

        setLoading(false);
    }, [walletData, memberSince]);

    const isMobile = {
        Android: function () {
            return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function () {
            return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function () {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function () {
            return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function () {
            return navigator.userAgent.match(/IEMobile/i);
        },
        any: function () {
            return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
        }
    };

    return (
        <div className="wallet-page-container">
            <div className="wallet-header">
                <div className="wallet-header-title">NBA ID MEMBER CARD</div>
                <div className="wallet-header-desc">
                    With your NBA ID Member Card, exclusive perks at NBA events are only a scan away.
                    {/*To add your NBA ID Member Card to your phone&apos;s wallet, tap one of the buttons below and
                    follow the steps on your screen.*/}
                </div>
            </div>
            <div className="wallet-qr-container">
                <div className="qr-header">
                    <div className="nba-id-logo"></div>
                </div>
                <div className="qr-body">
                    {loading &&
                        <div className="qr-loading-container">
                            <div className="loading"><span /><span /></div>
                        </div>
                    }
                    {!loading && <>
                        <div className="qr-title">{userName.givenName}</div>
                        <div className="qr-subtitle">
                            NBA ID Member Since&nbsp;
                            {
                                memberSince && `${new Intl.DateTimeFormat("en-US", { month: "long" }).format(memberSince * 1000)}
                            ${new Date(memberSince * 1000).getFullYear()}`
                            }
                        </div>
                    </>}
                    <div className="qr-container">
                        <canvas id="qr-code"></canvas>
                    </div>
                </div>
            </div>
            {walletData && <div className="wallet-app-links">
                <a className="add-to-google" href={walletData.google_url} title="Add to Google Wallet" data-track="click"
                    data-id="nba:membership-hub:member-card:wallet:cta" data-content="Google" data-type="cta">&nbsp;</a>
                {isMobile.iOS() && <a className="add-to-apple" href={walletData.apple_url} title="Add to Apple Wallet" data-track="click"
                    data-id="nba:membership-hub:member-card:wallet:cta" data-content="Apple" data-type="cta">&nbsp;</a>}
            </div>}
        </div>
    );
}

export default Wallet;
